<template>
  <div class="main-frame">
    <div class="info-frame">
      <van-nav-bar title="SMOK" class="top_bar" fixed>
        <!-- <van-nav-bar title="SMOK" class="top_bar" fixed @click-right="changeLanguage()"> -->
        <template #title>
          <img class="logo-img" src="../assets/image/smoklogo.png" />
        </template>
        <!-- 暂时屏蔽语言切换 -->
        <template #right>
          <van-icon name="exchange" size="20" color="#000" @click="changeLanguage()"/>
        </template>
      </van-nav-bar>
      <!-- 占位高度 -->
      <van-divider class="top-divider" :style="{ borderColor: '#FFF' }" />
      <!-- 说明文字 -->
      <p class="product_title">{{ $t("message.home_pro_title") }}</p>
      <p class="verify_title">{{ $t("message.home_verify_title") }}</p>
      <!-- 扫描二维码 -->
      <van-button
        type="info"
        icon="scan"
        class="button_scan"
        color="#30b3f0"
        @click="showModal = true"
        >{{ $t("message.home_button_scan") }}</van-button
      >
      <!-- 上传图片按钮-->
      <van-uploader
        class="upload-img"
        :max-count="1"
        :max-size="20 * 1024 * 1024"
        @oversize="onOversize"
        :before-read="asyncBeforeRead"
        :after-read="afterUpload"
      >
        <van-button icon="photo-o" type="info" color="#30b3f0" class="button_upload">{{
          $t("message.home_button_file")
        }}</van-button>
      </van-uploader>
      <van-button
        icon="wap-home-o"
        type="info"
        color="#30b3f0"
        class="button_scan"
        @click="downloadApp"
        >{{ $t("message.home_button_app") }}</van-button
      >
      <!-- 分割线 -->
      <van-divider
        :style="{
          color: '#F5F5F5',
          borderColor: '#F5F5F5',
          padding: '0 16px',
          height: '16px',
          background: '#F5F5F5',
        }"
      />
      <!-- 教程标题 -->
      <p class="qr_text">{{ $t("message.home_qr_text") }}</p>
      <!-- 教程内容 -->
      <p class="find_title">{{ $t("message.home_find_title") }}</p>
      <!-- AB码示例图片 -->
      <img class="fake_img" src="../assets/image/fake_img.png" alt="AB QR-Code" />
      <!-- 底部说明文字 -->
      <p class="verify_title">{{ $t("message.home_use_title") }}</p>
      <!-- 防伪码教程 -->
      <div class="fake_title">
        <a href="https://www.smoktech.com/web-anti-counterfeiting-system">{{
          $t("message.home_fake_title")
        }}</a>
      </div>
    </div>
    <div class="bottom-view">
      <!-- 装饰线条 -->
      <img class="img-margin" src="../assets/image/footer.png" />
      <!-- 版权说明 -->
      <foot></foot>
    </div>
    <!-- 访问摄像头提示弹窗 -->
    <van-popup v-model="showModal" round close-on-popstate closeable>
      <div class="pop-center">
        <img src="../assets/image/safe_icon.png" />
        <p>{{ $t("message.home_modal_hint") }}</p>
        <van-button
          class="btn_ok"
          color="#149cf7"
          type="primary"
          @click="openCamera()"
          block
          >{{ $t("message.home_modal_OK") }}</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import Fingerprint2 from "fingerprintjs2";
import axios from "axios";

import foot from "@/components/Foot.vue";
export default {
  components: {
    foot,
  },
  name: "BindHome",
  data() {
    return {
      id: "",
      showModal: false,
      lang_text: "简体中文",
      showLanguagePicker: false,
      languageList: ["English", "简体中文"],
      postData: {
        // eslint-disable-next-line
        access_key: ACCESS_KEY,
        device: "",
        info_code: "",
        // eslint-disable-next-line
        type: TYPE,
      },
      loading: true,
      files: {
        name: "",
        type: "",
      },
      headerImage: null,
      picValue: null,
      // eslint-disable-next-line
      img_upload: IMG_UPLOAD,
    };
  },
  methods: {
    getId() {
      //获取唯一id
      let _me = this;
      let options = {};
      Fingerprint2.get(options, function (components) {
        let values = components.map(function (component) {
          return component.value;
        });
        let murmur = Fingerprint2.x64hash128(values.join(""), 83777975);
        _me.id = murmur;
      });
    },
    downloadApp() {
      this.$router.push({ name: "home" });
    },
    openCamera() {
      this.showModal = false;
      // this.$refs.QRcodeRef.show(); //显示
      this.$router.push({ name: "scan", params: { type: "A" } });
    },
    // eslint-disable-next-line
    onOversize(file) {
      this.$notify("File is too large, no more than 20M.");
    },
    changeLanguage() {
      this.common.language = !this.common.language;
      if (this.common.language) {
        this.$i18n.locale = "cn";
      } else {
        this.$i18n.locale = "en";
      }
    },
    // eslint-disable-next-line
    asyncBeforeRead(file) {
      // 此处可以进行图片压缩
      return true;
    },
    async afterUpload(file) {
      this.$toast.loading({
        message: "Scanning...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      // 上传文件
      this.files.name = file.file.name; // 获取文件名
      this.files.type = file.file.type; // 获取类型
      this.picValue = file.file; // 文件流
      this.imgPreview(this.picValue);
    },
    // 处理图片
    imgPreview(file) {
      let self = this;
      let Orientation;
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          // console.log(this.result);
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于500K,是就直接上传，反之压缩图片
          if (this.result.length <= 500 * 1024) {
            self.headerImage = this.result;
            self.postImg();
          } else {
            img.onload = function () {
              let data = self.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
      var arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type,
      });
    },
    //这里写接口
    async postImg() {
      let _me = this;
      let file = this.dataURLtoFile(this.headerImage);
      let formData = new FormData();
      formData.append("file", file);
      axios({
        method: "post",
        url: this.img_upload,
        data: formData,
      })
        .then((res) => {
          _me.$toast.clear();
          // console.log(res);
          // 这里是为了识别A码
          // console.log(res.data.data);
          if (res.data.data == undefined || res.data.data.length == 0) {
            _me.$notify(_me.$t("message.home_model_not_scanner_code_a"));
          } else {
            // 检测是否有A码
            let qrCodeList = res.data.data;
            let codeAStr = _me.checkListHaveCodeA(qrCodeList);
            if (codeAStr.length > 0) {
              // console.log("识别到A码", codeAStr);
              _me.findCodeInfoByCodeA(codeAStr);
            } else {
              _me.$notify(_me.$t("message.home_model_not_scanner_code_a"));
            }
          }
        })
        .catch((err) => {
          _me.$toast.clear();
          _me.$notify("Web Error:", err.toString());
          // console.log(err);
        });
    },
    checkListHaveCodeA(codeList) {
      for (let i = 0; i < codeList.length; i++) {
        let codeAStr = codeList[i];
        // eslint-disable-next-line
        if (codeAStr.search(A_PREV) != -1) {
          return codeAStr;
        }
      }
      return "";
    },
    findCodeInfoByCodeA(codeAStr) {
      let _me = this;

      this.$toast.loading({
        message: "Loading...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      // 加入A码
      this.postData.info_code = codeAStr;

      this.common
        .httpPost("anti/fake/info/new", _me.postData)
        .then((res) => {
          _me.$toast.clear();
          // console.log(res)
          // 获取语言
          let text = res.data.message;
          if (res.data.status == 852003) {
            // 产品不是正品 ✔️
            _me.$router.push({ name: "A_fake", params: { text: text, code: codeAStr } });
          } else if (res.data.status == 852007) {
            // 骷颅头 ✔️
            _me.$router.push({
              name: "ABlackList",
              params: { text: text, code: codeAStr },
            });
          } else if (res.data.status == 852006) {
            // 产品未激活 ✔️
            res.data.fake.device_uuid = _me.id;
            _me.$router.push({ name: "A_nonactivate", params: { data: res.data.fake } });
          } else if (res.data.status == 852008) {
            // 产品已激活 - 本人查询
            _me.$router.push({
              name: "A_activate",
              params: { data: res.data.fake, status: 1 },
            });
          } else if (res.data.status == 852005) {
            // 产品已激活 - 非本人查询
            _me.$router.push({
              name: "A_activate",
              params: { data: res.data.fake, status: 2 },
            });
          } else if (res.data.status == 852004) {
            // 产品无记录 ✔️
            _me.$router.push({
              name: "A_nonrecord",
              params: { text: text, code: codeAStr },
            });
          } else {
            // 统一弹窗提醒
            _me.$notify(text);
          }
        })
        .catch((err) => {
          _me.$toast.clear();
          _me.$notify("Web Error:", err.toString());
          // console.log(err);
        });
    },
  },
  mounted() {
    this.getId();
  },
  watch: {
    // eslint-disable-next-line
    id: function (val, oldVal) {
      this.loading = false;
      this.postData.device = val;
    },
  },
};
</script>

<style scoped>
.main-frame {
  /*width: 100%;*/
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: white;
}

.info-frame {
  flex: 1;
}

.top_bar {
  height: 54px;
}

.logo-img {
  margin-top: 4px;
  height: 24px;
}

.top-divider {
  background-color: white;
  margin: 0;
  height: 55px;
}

.product_title {
  margin-left: 16px;
  margin-top: 16px;
  color: black;
  font-size: 16pt;
  font-weight: bold;
}

.verify_title {
  font-size: 12pt;
  /* font-weight: lighter; */
  margin-left: 16px;
  margin-top: 4px;
  color: #999;
}

.button_scan {
  margin-top: 16px;
  width: calc(100% - 32px);
  height: 40px;
  margin-left: 16px;
  border-radius: 6px;
}
.upload-img {
  margin-top: 14px;
  margin-left: 16px;
  width: calc(100% - 32px);
  height: 40px;
  background-color: white;
}

.button_upload {
  width: 100%;
  height: 40px;
  border-radius: 6px;
}

.qr_text {
  margin-top: 8px;
  margin-left: 16px;
  width: calc(100% - 32px);
  font-size: 14pt;
  font-weight: 500;
  color: #000;
}

.find_title {
  margin-top: 8px;
  margin-left: 16px;
  width: calc(100% - 32px);
  font-size: 12pt;
  /* font-weight: lighter; */
  color: #999;
}

.fake_img {
  margin-top: 16px;
  margin-left: 16px;
  max-width: 282px;
  border-radius: 8px;
}

.verify_title {
  margin-top: 8px;
  margin-left: 16px;
  width: calc(100% - 32px);
  font-size: 12pt;
  /* font-weight: lighter; */
  color: #999;
}

.fake_title {
  margin-top: 20px;
  margin-left: 16px;
  width: calc(100% - 32px);
  font-size: 12pt;
}

.fake_title a {
  color: #03aef9;
}

.img-margin {
  width: 100%;
  height: 22px;
}

.bottom-view {
  min-height: 50px;
  margin-top: 20px;
  background-color: white;
}

.pop-center {
  width: 280px;
  height: 290px;
}

.pop-center img {
  width: 110px;
  /* height: 110px; */
  margin-top: 30px;
  margin-left: 85px;
}

.pop-center p {
  margin-top: 25px;
  margin-left: 16px;
  margin-right: 16px;
  text-align: center;
  font-size: 12pt;
}

.btn_ok {
  position: absolute;
  bottom: 0;
}
</style>
